import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {updateCompanyInfo, HttpUpdateCompanyInfoOptions} from '@/features/company-info/http/company-info.http'
import {CompanyInfo} from '@/features/company-info/types'
import {AxiosError} from 'axios'
import {queryClient, QUERY_KEYS} from '@/queryClient'

export const useUpdateCompanyInfo = (
    options?: Omit<UseMutationOptions<CompanyInfo, AxiosError, HttpUpdateCompanyInfoOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationFn: payload =>
            updateCompanyInfo({
                payload,
                params: {responseType: 'extended'}
            }).then(response => response.data),
        onSuccess: (data, variables, context) => {
            // Invalidate company info query to refetch with updated data
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.COMPANY_INFO]})

            // Call the onSuccess handler if provided
            if (options?.onSuccess) {
                options.onSuccess(data, variables, context)
            }
        }
    })
}
